import { asset } from "@/lib/asset";
import { useRef, useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
import arrow from "@/assets/icons/arrow.svg";

const BlogCard = ({ title, description, image, link, date, external }) => {
  const [descriptionLines, setDescriptionLines] = useState(1);
  const descBoxRef = useRef(null);
  const descTextRef = useRef(null);

  useLayoutEffect(() => {
    const box = descBoxRef.current;
    const text = descTextRef.current;

    if (!box || !text) return;

    const updateLines = () => {
      const lineHeight = parseFloat(getComputedStyle(text).lineHeight);

      if (!Number.isFinite(lineHeight) || lineHeight <= 0) return;

      setDescriptionLines(
        Math.max(1, Math.floor(box.clientHeight / lineHeight)),
      );
    };

    updateLines();

    const observer = new ResizeObserver(updateLines);
    observer.observe(box);

    return () => observer.disconnect();
  }, []);

  return (
    <Link
      to={link}
      target={external ? "_blank" : "_self"}
      className="block w-[90%] sm:w-[345px] xl:w-[366px] h-[578px] xl:h-[587px] p-[16px] xl:p-5 bg-white rounded-[20px] shadow-[0px_2px_4px_1px_rgba(202,169,140,1.00)]"
    >
      <div className="flex flex-col w-full h-full">
        <img
          className="w-full h-auto shrink-0 xl:h-[200px] rounded-lg object-cover"
          src={asset(`/img/news/${image}.png`)}
          alt={title}
        />

        {/* Title */}
        <div className="mt-[21px] mb-[15px] shrink-0 text-xl xl:text-2xl font-bold bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text">
          {title}
        </div>

        {/* Description */}
        <div
          ref={descBoxRef}
          className="min-h-0 flex-1 overflow-hidden mb-[15px]"
        >
          <div
            ref={descTextRef}
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: descriptionLines,
              overflow: "hidden",
            }}
            className="text-[#544a28] text-base font-normal"
          >
            {description}
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-between items-end shrink-0 h-auto xl:h-[30px]">
          <div className="text-[#858585] text-base font-normal">{date}</div>
          <div className="flex items-center gap-2 text-[#c0834d] text-base font-normal">
            <span>Читать</span>
            <img
              src={arrow}
              alt=""
              aria-hidden="true"
              className="h-[21px] w-[25px] xl:w-[30px]"
            />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
